import React from 'react';
import { FJ710 } from '../../../services/c209Api';

interface Tab2Props {
  formData: Partial<FJ710>;
  isEditing: boolean;
  getField: (key: keyof FJ710) => FJ710[keyof FJ710];
  setField: (key: keyof FJ710, value: FJ710[keyof FJ710]) => void;
}

/** Tab 2: 來樣規格與加工需求 (Page2 in spec) */
const Tab2SampleSpecs: React.FC<Tab2Props> = React.memo(({
  formData, isEditing, getField, setField,
}) => (
  <div className="tab-content-section">
    <h3 className="section-title">來樣規格與加工需求</h3>

    {/* Product name (memo) */}
    <div className="memo-group">
      <label>產品名稱</label>
      <textarea
        value={getField('fj710_28') as string || ''}
        onChange={e => setField('fj710_28', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>

    {/* Product spec (memo) */}
    <div className="memo-group">
      <label>產品規格</label>
      <textarea
        value={getField('fj710_26') as string || ''}
        onChange={e => setField('fj710_26', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>

    {/* Processing type (memo) */}
    <div className="memo-group">
      <label>來樣加工別</label>
      <textarea
        value={getField('fj710_21') as string || ''}
        onChange={e => setField('fj710_21', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>

    {/* Processing requirements 1~5 (BR-C02 memo fields) */}
    <div className="memo-group">
      <label>加工需求 1</label>
      <textarea
        value={getField('fj710_221') as string || ''}
        onChange={e => setField('fj710_221', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>

    <div className="memo-group">
      <label>加工需求 2</label>
      <textarea
        value={getField('fj710_222') as string || ''}
        onChange={e => setField('fj710_222', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>

    <div className="memo-group">
      <label>加工需求 3</label>
      <textarea
        value={getField('fj710_223') as string || ''}
        onChange={e => setField('fj710_223', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>

    <div className="memo-group">
      <label>加工需求 4</label>
      <textarea
        value={getField('fj710_224') as string || ''}
        onChange={e => setField('fj710_224', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>

    <div className="memo-group">
      <label>加工需求 5</label>
      <textarea
        value={getField('fj710_225') as string || ''}
        onChange={e => setField('fj710_225', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={3}
        style={{ width: '100%' }}
      />
    </div>
  </div>
));

Tab2SampleSpecs.displayName = 'Tab2SampleSpecs';

export default Tab2SampleSpecs;
